import router, { authRouteNames } from '@/router'

// 模块级别的共享状态（单例）
// 打开登录页、购买页之前所在的地址，完成或返回时回到这里
let authReturnPath = '/'
let pricingReturnPath = '/'

function openAuthPage(name) {
  const route = router.currentRoute.value
  if (!authRouteNames.includes(route.name)) authReturnPath = route.fullPath
  router.push({ name })
}

export function getAuthReturnPath() {
  return authReturnPath
}

export function getPricingReturnPath() {
  return pricingReturnPath
}

export function useModals() {
  const showLoginModal = () => openAuthPage('Login')

  const showSignupModal = () => openAuthPage('Signup')

  // 生成工具使用独立页面，现有入口统一导航到对应地址。
  const showTranscribeInterface = () => router.push('/create/transcribe')
  const showYouTubeImporter = () => router.push('/create/youtube')
  const showTextToSpeech = () => router.push('/create/speech')

  // 购买页；从登录页回来时不覆盖最初的来处
  const handleUpgrade = (purchaseMode = 'subscription') => {
    const route = router.currentRoute.value
    if (route.name !== 'Pricing' && !authRouteNames.includes(route.name)) pricingReturnPath = route.fullPath
    router.push({ name: 'Pricing', query: purchaseMode === 'credits' ? { mode: 'credits' } : {} })
  }

  return {
    showLoginModal,
    showSignupModal,
    showTranscribeInterface,
    showYouTubeImporter,
    showTextToSpeech,
    handleUpgrade
  }
}
